<template>
  <div>
    <BannerHero
      segment="enterprise"
      :badge="{
        text: 'VMware advantage partner',
        icon: IconAward,
      }"
      :heading="`Ne<span class='uppercase'>e</span>d a VMware pa<span class='uppercase'>r</span>tner? <span class='xs:whitespace-nowrap'>Aussie Broadband</span> can help`"
      subheading="The Aussie Broadband team is thrilled to be a Premier Partner in the Broadcom Advantage Partner Program for VMware Cloud Service Providers (VCSP)."
      description="Submit your details and one of our experts will be in contact to discuss how Aussie Broadband can deliver a smooth transition and support for VMware licensing."
      :usps="uspData"
    />
    <section id="contact" class="container spacing-white">
      <FormEnterpriseEnquiry
        heading="Contact Us"
        title="Speak to our team about your VMware needs"
        desc="Enter your details below and a member of our team will reach out for an initial chat."
        :custom-interests="[
          {
            value: 'VMware',
            text: 'VMware',
          },
        ]"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import IconAward from "@/components/icon/Award.vue";
const uspData = [
  {
    name: "100% Australian-based",
    icon: resolveComponent("IconAustralianBased"),
  },
  {
    name: "4.6 Stars from 10,000+ reviews",
    icon: resolveComponent("IconStar"),
  },
];

useHead({
  title: "VMware Partner | Aussie Broadband",
  meta: [{ hid: "robots", name: "robots", content: "noindex" }],
});
</script>
